<template>
  <!-- 学术系统/个人赛/团体赛使用 -->
    <div :class="isItso ? 'itso' : itemData.isNational ? 'national' : ''">
      <!-- 'card-background' + (itemIndex + 1) -->
        <div
            shadow="hover"
            style="border: none"
            class="system-btn"
            @click="scheduleCardTap(itemData)"
            :class="
                this.hasPerms(
                    itemData.authorityFlag
                        ? itemData.authorityFlag
                        : itemData.flag
                ) === true
                    ? ( itemData.icon ? ('card-background' + (itemIndex + 1)) : 'card-background')
                    : 'card-backgroundgray'
            "
        >
            <i v-if="itemData.icon" class="icon iconfont" :class="itemData.icon"></i>
            <div>
                <div class="schedule_gameName" :class="isItso ? '' : 'ml-20'">
                    {{ itemData.scheduleName }}
                </div>
                <div class="en">
                  {{ itemData.scheduleEnName }}
                </div>
                <!-- <div class="schedule_gameNumber" v-if="itemData.promotionNum">
                参赛 {{ itemData.signUpNum }} <br />
                晋级 {{ itemData.promotionNum }}
            </div> -->
                <div class="schedule_gameNumber" v-if="!isItso">
                    {{ itemData.descStr }}
                </div>
            </div>
            <!-- <img v-if="!itemData.icon && !isItso" class="logo" :src=" itemData.isNational ? require('../assets/img/season11-4.jpg') : 'https://cdn.spbcn.org/spbcnWeb/pic/new_homepage_imgicon6.png'" alt=""> -->
            <!-- <el-progress
                v-if="itemData.promotionNum"
                class="schedule-progress"
                type="circle"
                :percentage="itemData.percent"
                color="#ffffff"
                define-back-color="rgba(255,255,255,0.3)"
                :show-text="false"
                :width="42"
                stroke-linecap="square"
                :stroke-width="8"
            ></el-progress> -->
        </div>
    </div>
</template>

<script>
import { hasPermission } from '@/permission/index.js'
export default {
  props: {
    itemData: {
      type: Object,
      default: function () { return {} }
    },
    itemIndex: {
      type: Number
    },
    isItso: {
      type: Boolean
    }
  },
  methods: {
    scheduleCardTap (itemData) {
      console.log(itemData)
      if (this.hasPerms(itemData.authorityFlag ? itemData.authorityFlag : itemData.flag)) {
        this.$emit('itemClicked', itemData)
      } else {
        this.$message.warning('暂无操作权限')
      }
    },
    hasPerms: function (perms) {
      // 根据权限标识和外部指示状态进行权限判断
      return hasPermission(perms) // & !this.disabled
    }
  }
}
</script>

<style lang="less" scoped>
.system-btn {
    border-radius: 8px;
    padding: 20px 0;
    height: 60px;
    margin-right: 20px;
    color: #fff;
    display: flex;
    align-items: center;
    position: relative;
    // width: 260px;
    .icon {
        padding: 8px 10px;
        margin-left: 20px;
       font-size: 30px;
        background-color: rgba(255, 255, 255, 0.7);
        border-radius: 100%;
    }
    .schedule_gameName {
        text-align: left;
        color: white;
        font-size: 20px;
        font-weight: 600;
        // margin-bottom: 6px;
        // margin-left: 20px;
        &.w120{
          width: 120px;
        }
        &.ml-20{
          margin-left: 20px;
        }
    }
    .en{
      font-size: 12px;
      margin-left: 20px;
    }

    .schedule_gameNumber {
        text-align: left;
        color: white;
        font-size: 12px;
        margin-left: 20px;
    }
    &:hover{
      .schedule_gameName{
        text-decoration: underline;
      }
      box-shadow: 0 4px 12px 0 rgba(0,0,0,.5);
    }
    .logo{
      position: absolute;
      right: 0;
      top: 14px;
      height: 40px;
      right: 14px;
    }
}
.national .logo{
  height: 80px;
  top: 10px;
  right: 0;
}
.card-background{
  // background-image: url(../assets/img/season11-4.jpg);
  background-image: url(https://cdn.spbcn.org/spbcnWeb/spbcn/logo-season12-icon.png?v=2026);
  background-color: #011A52;
  background-size: auto 70%;
  background-repeat: no-repeat;
  background-position: right center;
  .schedule_gameName{
    font-weight: bold;
    // background: linear-gradient(180deg, #E7E49C, #BB8F48);
    // -webkit-background-clip: text;
    // -webkit-text-fill-color: transparent;
    // background-clip: text;
    color: #D0B269;
  }
  .en{
    color: #D0B269;
  }
}
.itso .card-background{
  background-image: url(https://cdn.spbcn.org/spbcnapp/2025ui/itso/final/banner.png);
  background-color: #000;
  background-size: auto 72%;
  background-repeat: no-repeat;
  background-position: top center;
  height: 76px;
  align-items: flex-end;
  justify-content: center;
  padding-bottom: 10px;
  .schedule_gameName{
    color: #F67800;
  }
}
// .national .card-background{
//   background-image: linear-gradient(to bottom, #040A4A, #122AC9);
// }
</style>
